import testJson from '@/mock/json/test.json'
import type { DashboardDataFromParent } from '@/store/modules/parentData'

/** 演示账号：该用户进入大屏时使用假数据，不请求业务接口 */
export const DEMO_USERNAME = '15516751561'

let demoMode = false

export const isDemoMode = () => demoMode

export const setDemoMode = (enabled: boolean) => {
  demoMode = !!enabled
}

/**
 * 根据 user_info 判断是否进入演示模式
 * @returns 是否为演示账号
 */
export const applyDemoModeByUserInfo = (userInfo: { username?: string | number } | null | undefined) => {
  const username = userInfo?.username != null ? String(userInfo.username) : ''
  const enabled = username === DEMO_USERNAME
  setDemoMode(enabled)
  return enabled
}

/**
 * 业务分布率等面板数据：基于 test.json 台账规模推导，不另起接口
 */
export const getDemoDashboardData = (): DashboardDataFromParent => {
  const records = Array.isArray((testJson as { data?: Array<{ transfer_amount?: string | null }> })?.data)
    ? (testJson as { data: Array<{ transfer_amount?: string | null }> }).data
    : []
  const loanCount = records.length || 999

  // 漏斗放大：评估 > 预审 > 合同 > 放款
  const evaluations = Math.round(loanCount * 4.8)
  const prequalifications = Math.round(loanCount * 3.2)
  const contracts = Math.round(loanCount * 1.6)
  const loans = loanCount

  let totalAmount = 0
  for (const item of records) {
    totalAmount += Number.parseFloat(item?.transfer_amount || '0') || 0
  }

  return {
    consumption: {
      total: Math.round(totalAmount),
      year: Math.round(totalAmount * 0.85),
      month: Math.round(totalAmount * 0.18),
      today: Math.round(totalAmount * 0.03),
    },
    today_overview: {
      eval_count: Math.round(evaluations * 0.04),
      eval_cost: Math.round(totalAmount * 0.002),
      pre_count: Math.round(prequalifications * 0.04),
      pre_cost: Math.round(totalAmount * 0.003),
      contract_count: Math.round(contracts * 0.04),
      contract_cost: Math.round(totalAmount * 0.004),
    },
    business_overview: {
      evaluations,
      prequalifications,
      contracts,
      loans,
    },
    charts: {
      pie: [
        { name: '评估', value: evaluations },
        { name: '预审', value: prequalifications },
        { name: '合同', value: contracts },
        { name: '放款', value: loans },
      ],
      heatmap: [],
      trends: {
        evaluation_trend: [],
        prequalification_trend: [],
      },
    },
  }
}
